'use client';

import { useEffect, useState } from 'react';
import { getQuizQuestions } from '@/lib/api/client';
import { QuizForm } from './quiz-form';
import { QuizQuestion } from '@/types/dogs';

export default function QuizContent() {
  const [questions, setQuestions] = useState<QuizQuestion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const data = await getQuizQuestions();
        setQuestions(data);
      } catch {
        setError('Failed to load quiz questions. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center">Loading quiz questions...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center text-red-600">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Find Your Perfect Dog Breed</h1>
        <p className="text-gray-600 mb-8">
          Answer a few questions about your lifestyle and preferences, and we'll help you find
          the perfect dog breed match.
        </p>
        <QuizForm questions={questions} />
      </div>
    </div>
  );
} 